

<body class="mat-app-background">
    <div class="container-fluid">
        <div class="row ccorbit-form-group without-icon m-2 p-2">
            <div class="col-6">
                <div class="row">
                    <div class="row">
                        <div class="col-10">Periodo Analizado</div>
                        <div class="col-2">0</div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-10">Periodo Que Cumplen el Rango de Volatilidad</div>
                        <div class="col-2">0</div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-10">Periodo Donde hay Rango de Variacion Mayor</div>
                        <div class="col-2">0</div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-10">Periodo Donde hay Rango de Variacion Menor</div>
                        <div class="col-2">0</div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-10">Periodo al que Fecha fin del Periodo el Rango es Mayor</div>
                        <div class="col-2">0</div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-10">Periodo al que Fecha fin del Periodo el Rango es Menor</div>
                        <div class="col-2">0</div>
                    </div>
            
                </div>
            </div>
            <div class="col-6">
                <div class="row">
                    <div class="col-6">
                        <cdk-virtual-scroll-viewport #viewportGestion id="viewportGestion" item [appendOnly]="false"
                        [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
                        <table cdk-table [dataSource]="opedata" class="table-striped tableStyle">
    
                            <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
                            <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
                                [ngClass]="{'selected': row === filaSeleccionada}"></tr>
                            <ng-container *ngFor="let tablecol of tableColumns">
    
                                <ng-container [cdkColumnDef]="tablecol.id">
                                    <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
                                        {{tablecol.name}}
                                    </th>
                                    <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                              'entrada': item[tablecol.id] === 'ENTRADA',
                                                              'numero-positivo': item[tablecol.id] > 0,
                                                              'numero-negativo': item[tablecol.id] < 0
                                                              }">
                                        <ng-container *ngIf="tablecol.isString">
                                            {{item[tablecol.id]}}
                                        </ng-container>
                                        <ng-container *ngIf="tablecol.isDate">
                                            {{item[tablecol.id] | smartDate }}
                                        </ng-container>
                                        <ng-container *ngIf="tablecol.isNumber">
                                            {{item[tablecol.id] |number:'1.2-2'}}
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </ng-container>
                        </table>
                    </cdk-virtual-scroll-viewport>
                    <div class="row">
                        <!--          <div class="col-4">
    
                    </div> -->
                        <div class="col-12" style="padding-bottom: 0.5rem; padding-top: 0.5rem;">
                            <input type="text" name="" id="">
                        </div>
                    </div>
                    </div>
                    <div class="col-6">
                        <cdk-virtual-scroll-viewport #viewportGestion id="viewportGestion" item [appendOnly]="false"
                        [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
                        <table cdk-table [dataSource]="opedata" class="table-striped tableStyle">
    
                            <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
                            <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
                                [ngClass]="{'selected': row === filaSeleccionada}"></tr>
                            <ng-container *ngFor="let tablecol of tableColumns">
    
                                <ng-container [cdkColumnDef]="tablecol.id">
                                    <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
                                        {{tablecol.name}}
                                    </th>
                                    <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                              'entrada': item[tablecol.id] === 'ENTRADA',
                                                              'numero-positivo': item[tablecol.id] > 0,
                                                              'numero-negativo': item[tablecol.id] < 0
                                                              }">
                                        <ng-container *ngIf="tablecol.isString">
                                            {{item[tablecol.id]}}
                                        </ng-container>
                                        <ng-container *ngIf="tablecol.isDate">
                                            {{item[tablecol.id] | smartDate }}
                                        </ng-container>
                                        <ng-container *ngIf="tablecol.isNumber">
                                            {{item[tablecol.id] |number:'1.2-2'}}
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </ng-container>
                        </table>
                    </cdk-virtual-scroll-viewport>
                    <div class="row">
                        <!--          <div class="col-4">
    
                    </div> -->
                        <div class="col-12" style="padding-bottom: 0.5rem; padding-top: 0.5rem;">
                            <input type="text" name="" id="">
                        </div>
                    </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</body>
